export default "__VITE_ASSET__9398eaa3__"